import "../reports.css";
import { useLanguage } from "../../../hooks";

const ReportUnknown: React.FC = () => {
  const { t } = useLanguage();

  return (
    <>
      <td>
        <p>{t.reportsScreen.table.tbody.tabMistake}</p>
      </td>
    </>
  );
};

export default ReportUnknown;
